import React from 'react';
import { observer } from 'mobx-react';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';
import { useStore } from '@ui/hooks/useStore';
import AddDeviceContainer from './Add-device.container';
import AddDeviceTableContainer from '../Add-device-table/Add-device-table.container';

const Container = ({ onClose }: ICloseEvent) => {
    const { download } = useStore();
    if (download.uploadedDevices && download.uploadedDevices.length > 0)
        return (
            <>
                <AddDeviceTableContainer onClose={onClose} />
            </>
        );
    else
        return (
            <>
                <AddDeviceContainer onClose={onClose} />
            </>
        );
};

const AddDeviceMainContainer = observer(Container);

export default AddDeviceMainContainer;
